import angular from 'angular';

function TitlecaseFilter() {
	return function(s) {
        s = ( s === undefined || s === null ) ? '' : s;
        return s.toString().toLowerCase().replace( /\b([a-z])/g, ch => ch.toUpperCase());
    };
}

export default angular.module('filters.titlecase-filter', [])
	.filter('titlecase', TitlecaseFilter)
	.name;



// WEBPACK FOOTER //
// ./project/filters/titlecase.js